"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseButton = exports.CloseIcon = exports.CardHeader = exports.Card = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _GenericStyles = require("../../GenericStyles");

var _Themes = require("../../Themes");

var _Icons = require("../../Icons");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Card = (0, _styledComponents["default"])(_GenericStyles.Card).withConfig({
  displayName: "styles__Card",
  componentId: "sc-1qag6pi-0"
})(["position:relative;max-width:80vw;max-height:80vh;min-width:10vw;min-height:10vh;height:unset;overflow:", ";border-radius:4px;box-shadow:0 4px 15px 0 rgba(0,0,0,0.2);background-color:", ";margin:0px !important;"], function (props) {
  return props.overflow ? props.overflow : 'unset';
}, function (props) {
  return (0, _Themes.handleThemeFromObject)(props.theme, 'dialog.card', '#ffffff');
});
exports.Card = Card;

var CardHeader = _styledComponents["default"].div.withConfig({
  displayName: "styles__CardHeader",
  componentId: "sc-1qag6pi-1"
})(["padding:16px 24px;white-space:nowrap;font-family:inherit;font-size:20px;font-weight:bold;text-align:", ";color:", ";border-bottom:1px solid ", ";"], function (props) {
  return props.labelAlign;
}, function (props) {
  return (0, _Themes.handleThemeFromObject)(props.theme, 'dialog.header', '#717171');
}, function (props) {
  return (0, _Themes.handleThemeFromObject)(props.theme, 'dialog.separator', '#e6e6e6');
});

exports.CardHeader = CardHeader;
var CloseIcon = (0, _styledComponents["default"])(_Icons.FaTimes).withConfig({
  displayName: "styles__CloseIcon",
  componentId: "sc-1qag6pi-2"
})(["width:23px;height:23px;fill:", ";"], function (props) {
  return (0, _Themes.handleThemeFromObject)(props.theme, 'dialog.header', '#717171');
});
exports.CloseIcon = CloseIcon;

var CloseButton = _styledComponents["default"].div.withConfig({
  displayName: "styles__CloseButton",
  componentId: "sc-1qag6pi-3"
})(["position:absolute;padding:", ";top:0;right:0;cursor:pointer;"], function (props) {
  return props.closeButtonPadding;
});

exports.CloseButton = CloseButton;